export interface MaestroState {
  isNavigatingMaestro: boolean;
  setIsNavigatingMaestro: (isNavigatingMaestro: boolean) => void;
  maestroRequestData: any;
  setMaestroRequestData: (maestroRequestData: any) => void;
  clearMaestroRequestData: () => void;
  maestroResponseData: any;
  setMaestroResponseData: (maestroResponseData: any) => void;
  clearMaestroResponseData: () => void;
}

export enum StoreKeys {
  IS_NAVIGATING_MAESTRO = 'isNavigatingMaestro',
  SET_IS_NAVIGATING_MAESTRO = 'setIsNavigatingMaestro',
  MAESTRO_REQUEST_DATA = 'maestroRequestData',
  SET_MAESTRO_REQUEST_DATA = 'setMaestroRequestData',
  CLEAR_MAESTRO_REQUEST_DATA = 'clearMaestroRequestData',
  MAESTRO_RESPONSE_DATA = 'maestroResponseData',
  SET_MAESTRO_RESPONSE_DATA = 'setMaestroResponseData',
  CLEAR_MAESTRO_RESPONSE_DATA = 'clearMaestroResponseData',
}

export const initialState = {
  [StoreKeys.IS_NAVIGATING_MAESTRO]: false,
  [StoreKeys.MAESTRO_REQUEST_DATA]: {},
  [StoreKeys.MAESTRO_RESPONSE_DATA]: {},
};

export const PERSIST_KEYS = [
  StoreKeys.MAESTRO_REQUEST_DATA,
  StoreKeys.MAESTRO_RESPONSE_DATA,
];
